import React, { memo } from 'react'
import { InlineDisplayWrapper } from 'apps/fleet-planner/components/load-details/InlineDisplayWrapper'
import * as Types from 'apps/fleet-planner/types'
import { Avatar } from 'transfix-ui'

interface IDispatcherInlineDisplayProps extends Types.IInlineDisplayProps<Types.IDispatcher> {}

export const DispatcherInlineDisplay = memo<IDispatcherInlineDisplayProps>(
  ({ value: valueProp }) => {
    const { fullName: fullNameProp, id: idProp } = valueProp || {}
    const fullName = idProp ? fullNameProp : undefined
    return (
      <InlineDisplayWrapper
        label='Dispatcher'
        value={
          <div className='flex items-center'>
            <Avatar
              name={fullNameProp === 'Unassigned' || !idProp ? undefined : fullNameProp}
              tooltipName={fullName ?? 'Unassigned'}
              size='xsmall'
            />
            <p className='ml2'>{fullName ?? 'Unassigned'}</p>
          </div>
        }
      />
    )
  }
)
